import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiUploadCloud, FiLink, FiFileText } = FiIcons;

export default function SourcePanel({ source, setSource, videoUrl, setVideoUrl, script, setScript }) {
  const readScript = async (event) => {
    const file = event.target.files?.[0];
    if (file) setScript(await file.text());
  };

  return (
    <aside className="source-panel">
      <div className="section-heading">
        <span>01</span>
        <div><h2>Source material</h2><p>Footage and screenplay</p></div>
      </div>
      <label className="drop-zone">
        <SafeIcon icon={FiUploadCloud} />
        <strong>{source?.name || 'Choose video'}</strong>
        <span>MP4, WebM, MOV where supported</span>
        <input type="file" accept="video/*" onChange={(e) => setSource(e.target.files?.[0] || null)} />
      </label>
      <div className="or"><span>OR</span></div>
      <label className="field">
        <span><SafeIcon icon={FiLink} /> Public video URL</span>
        <input value={videoUrl} onChange={(e) => setVideoUrl(e.target.value)} placeholder="https://…" />
      </label>
      <div className="script-label">
        <span><SafeIcon icon={FiFileText} /> Screenplay</span>
        <label>Upload text<input type="file" accept=".txt,.md,.fountain" onChange={readScript} /></label>
      </div>
      <textarea
        className="script-input"
        value={script}
        onChange={(e) => setScript(e.target.value)}
        placeholder="Paste screenplay text here…"
      />
    </aside>
  );
}